import React from 'react';
import '../../assets/css/loading/loading.css';

const LoginLoading = () => {
  return (
    <div className="login-loading-container">
      <div className="login-loading-content">
        <img className='logo' src="/logo192.png" alt="logo" />
        <div className="spinner"></div>
        <p>Please wait, we are logging you in...</p>
      </div>
    </div>
  );
};

export default LoginLoading;
